<template>
  <v-card class="select-bookings" height="90vh">
    <v-card-title>{{ $t('admin_acc_purchase_order.add_recurrent_bookings') }}</v-card-title>
    <v-card-text>
      <AdminRecurrentBookingList full-height
                                 hide-actions
                                 show-select
                                 v-model="bookingIds"
                                 :extra-filters="extraFilters"></AdminRecurrentBookingList>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary"
             @click="$emit('submit')">
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$emit('submit', bookingIds)">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {ref} from "@vue/composition-api";

export default {
  name: 'SelectRecurrentBookingModal',
  components: {AdminRecurrentBookingList: () => import("@/components/acc_booking/booking/AdminRecurrentBookingList.vue")},
  props: {
    bookingRecordId: String,
    extraFilters: Object,
  },
  setup(props, {root, emit}) {
    const bookingIds = ref([]);

    return {
      bookingIds,
    }
  }
}
</script>

<style lang="less">
.select-bookings {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }

  .select-bookings-content {
    width: 100%;
    height: 100%;

    display: flex;
    gap: 12px;
  }
}


</style>
